import { identity } from 'lodash';

export type Pattern = number | symbol | string | string[] | ((entity: any) => boolean);

const patternTestFactory = ({ transform = identity }: { transform?: (param: any) => any } = {}) => (
    entity: any,
    pattern: Pattern,
) => {
    const transformed = transform(entity);

    if (typeof pattern === 'function') {
        return pattern(entity);
    }
    if (typeof pattern === 'string') {
        return transformed === pattern;
    }
    if (Array.isArray(pattern)) {
        return pattern.includes(transformed);
    }
    return false;
};

export const actionPatternTest = patternTestFactory({ transform: action => action.type });
export const listIdPatternTest = patternTestFactory();
